export default {
    name: "Tracking",
    meta: {
        icon: "note_add",
        expanded: true,
        auth: true
    },

    departmentName: "Tracking",
    finalPagePermision: "",

    children: [{

        name: "Containers",
        path: "/tracking/containers",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/allModuleForm/globalTracking.vue"),
        finalPagePermision: "",

    },
    {

        name: "Subscription Track",
        path: "/tracking/totsubscription",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/allModuleForm/totalSubscriptionTrack.vue"),
        finalPagePermision: "",

    },
    {

        name: "Ocean Insights Track",
        path: "/tracking/ocean-insights",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/ocean-insights/containerTrack.vue"),
        finalPagePermision: "",

    },
    {

        name: "E-Mail Log List",
        path: "/log/email-log",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/clientKycTemp/EmailLogList.vue"),
        finalPagePermision: "",
    },
    {

        name: "Failed Additional Task List",
        path: "/log/additional-task-failed",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/expense/FailedAdditionalTaskList.vue"),
        finalPagePermision: "",
    },
    {

        name: "Failed Manifestation List",
        path: "/log/manifestation-failed",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/expense/FailedManifestationList.vue"),
        finalPagePermision: "",
    },
    {

        name: "Failed Expense List",
        path: "/log/expense-failed",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/expense/FailedExpenseList.vue"),
        finalPagePermision: "",
    },
    {

        name: "Failed Prealert List",
        path: "/log/prealert-failed",
        meta: {
            icon: "note_add",
            auth: true
        },
        component: require("../component/containerDash/FailedPrealertList.vue"),
        finalPagePermision: "",
    },
    ]
};


// WEBPACK FOOTER //
// ./src/sidebar/tracking.js